enum UserEvents {

    // ユーザー認証
    AuthnStart = "[User] AuthnStart",
    AuthnComplete = "[User] AuthnComplete",


    // ユーザー認証
    AuthStart = "[User] AuthStart",
    AuthComplete = "[User] AuthComplete",


    // ログインユーザー情報取得
    LoginStarted = "[User] LoginStarted",
    LoginComplete = "[User] LoginComplete",
    SignOut = "[User] SignOut",
    //ユーザー一覧取得
    GetUserInfoListStarted = "[User] GetUserInfoListStarted",
    GetUserInfoListComplete = "[User] GetUserInfoListComplete",
    // ユーザ一覧更新
    UpdateUserInfoStarted = "[User] UpdateUserInfoStarted",
    UpdateUserInfoComplete = "[User] UpdateUserInfoComplete",
    UpdateUserInfoFailed = "[User] UpdateUserInfoFailed",

    // ユーザ一プロファイル画像更新
    UpdateUserProfileImageStarted = "[User] UpdateUserProfileImageStarted",
    UpdateUserProfileImageComplete = "[User] UpdateUserProfileImageComplete",
    UpdateUserProfileImageFailed = "[User] UpdateUserProfileImageFailed",
    // スキル一覧更新
    GetSkillListStarted = "[User] GetSkillListStarted",
    GetSkillListComplete = "[User] GetSkillListComplete",

    // ユーザー情報同期バッチを実行
    StartSyncBatch = "[User] StartSyncBatch",
    StartSyncBatchComplete = "[User] StartSyncBatchComplete",
    StartSyncBatchFailed = "[User] StartSyncBatchFailed",

    // ユーザー情報同期バッチを実行
    ValidateSSOTokenStarted = "[User] ValidateSSOTokenStarted",
    ValidateSSOTokenSuccess = "[User] ValidateSSOTokenSuccess",
    ValidateSSOTokenFailure = "[User] ValidateSSOTokenFailure",

}
export default UserEvents;
